import * as React from "react";

export function IconTray(props: any) {
  return <div></div>;
}
